/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
/* global fetch */
import React, { Component } from "react";
import { Input, Button, Row, FormGroup, Label, Tooltip } from "reactstrap";
import * as Constdata from "../../Constants/ApiConstants";
import * as message from "../../Constants/MessageConstant";
import SerraLoader from "../CommonComponent/Loader";
import SerraError from "../CommonComponent/Error";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiFetch } from "../../Constants/CommonConstant";

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    type="text"
    className="form-control"
    onClick={onClick}
    ref={ref}
    // readOnly
    value={value}
    placeholder="Select date & time"
  />
));
class Preferences extends Component {
  constructor(props) {
    super(props);
    this.changeUnit = this.changeUnit.bind(this);
    this.changeDuration = this.changeDuration.bind(this);
    this.changeParkingUnit = this.changeParkingUnit.bind(this);
    this.changeParkingDuration = this.changeParkingDuration.bind(this);
    this.manageAction = this.manageAction.bind(this);
    this.savePref = this.savePref.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.changeInterval = this.changeInterval.bind(this);
    this.toggleTooltips = this.toggleTooltips.bind(this);
    this.freeTrialPlanSupport = this.freeTrialPlanSupport.bind(this);
    this.changeIntervalAbsolute = this.changeIntervalAbsolute.bind(this);
    this.handleAbsoluteChange = this.handleAbsoluteChange.bind(this);
    this.formatWithTZ = this.formatWithTZ.bind(this);
    this.state = {
      unit: "days",
      duration: 7,
      parkingDuration: 17,
      parkingUnit: "days",
      enableSave: false,
      errorPopup: false,
      modalLoader: false,
      isErrorHeader: true,
      errormessage: "",
      isRedirect: false,
      max: 24,
      interval: 5,
      provider: props.providerName,
      tooltipOpen: false,
      tooltipIntervalOpen: false,
      userName: props.userName,
      isFreeTrial: props.isFreeTrial,
      min: 1,
      errorMsgDuration: "",
      durationType: "RELATIVE",
      endDate: new Date(),
      startDate: new Date(),
      absFrequency: 5,
      durationResponse: [],
      maxEndDate: new Date(),
      minEndDate: null,

      maxStartDate: null,
      minStartDate: null,
      selectedZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  }

  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.history.push("/");
    }
  };

  async changeUnit(event) {
    document.getElementById("duration").setAttribute("min", 1);
    let unitValue = event.target.value;
    await this.setState({ unit: event.target.value });
    if (unitValue === "hours") {
      document.getElementById("duration").setAttribute("max", 120);
      await this.setState({ duration: 24 });
    } else if (unitValue === "days") {
      if (this.state.interval === 1) {
        document.getElementById("duration").setAttribute("max", 15);
        await this.setState({ duration: 17 });
      } else {
        document.getElementById("duration").setAttribute("max", 60);
      }
    } else {
      document.getElementById("duration").setAttribute("max", 5 * 60 + 1);

      if (this.state.interval === 1) {
        document.getElementById("duration").setAttribute("min", 30);
        await this.setState({ duration: 30 });
      } else {
        document.getElementById("duration").setAttribute("min", 30);
        await this.setState({ duration: 30 });
      }
    }

    if (this.state.interval === 5 && unitValue === "hours") {
      if (this.state.duration < 6) {
        this.setState({ duration: 5 });
      }
    }
    await this.manageAction();
  }

  changeParkingUnit(event) {
    this.setState({ unit: event.target.value });
    this.manageAction();
  }

  keyPress(e) {
    if (e.keyCode === 190 || e.keyCode === 110) {
      e.preventDefault();
    }
  }
  async changeDuration(e) {
    const value = e.target.value.replace(/[^\d]/, "");
    var upperLimit = 120;
    if (this.state.unit === "hours") {
      upperLimit = 120 + 1;
    }
    if (this.state.unit === "minutes") {
      upperLimit = 60 * 5 + 1;
    }

    if (this.state.unit === "days") {
      if (this.state.interval === 1) {
        upperLimit = 15 + 1;
      } else if (this.state.interval === 5) {
        upperLimit = 60 + 1;
      }
    }

    if (
      value === "" ||
      (parseInt(value) !== 0 &&
        parseInt(value) > 0 &&
        parseInt(value) < upperLimit)
    ) {
      await this.setState({ duration: value });
      await this.manageAction();
    }
  }

  async changeParkingDuration(e) {
    const value = e.target.value.replace(/[^\d]/, "");
    if (value === "" || (parseInt(value) > 0 && parseInt(value) < 18)) {
      await this.setState({ parkingDuration: value });
      await this.manageAction();
    }
  }

  async manageAction() {
    if (this.state.durationType === "ABSOLUTE") {
      const dateUtcStart = new Date(this.state.startDate).getTime();
      const dateUtcEnd = new Date(this.state.endDate).getTime();

      if (dateUtcStart === dateUtcEnd) {
        await this.setState({ enableSave: false });
      } else {
        await this.setState({ enableSave: true });
      }
    } else {
      await this.setState({ errorMsgDuration: "" });
      var upperLimit = 120;
      var lowerLimit = true;

      if (this.state.unit === "hours") {
        upperLimit = 120 + 1;
      }

      if (this.state.unit === "days") {
        upperLimit = 15 + 1;

        if (this.state.duration > upperLimit && this.state.interval === 1) {
          lowerLimit = false;
        } else {
          upperLimit = 60 + 1;
        }
      }

      if (this.state.unit === "minutes") {
        upperLimit = 60 * 5 + 1;

        if (this.state.duration > upperLimit && this.state.interval === 1) {
          lowerLimit = false;
        } else if (this.state.duration < 30 && this.state.interval === 5) {
          lowerLimit = false;
        }
      }

      if (
        this.state.interval === 5 &&
        this.state.unit === "hours" &&
        parseInt(this.state.duration) < 5
      ) {
        await this.setState({
          errorMsgDuration: "For 5 min fidelity, min duration should be 5 hrs.",
        });
        lowerLimit = false;
      }

      if (
        this.state.interval === 5 &&
        this.state.unit === "minutes" &&
        parseInt(this.state.duration) < 30
      ) {
        await this.setState({
          errorMsgDuration:
            "For 5 min fidelity, duration should be at least 30 minutes",
        });
        lowerLimit = false;
      }

      if (
        this.state.interval === 1 &&
        this.state.unit === "minutes" &&
        parseInt(this.state.duration) < 30
      ) {
        await this.setState({
          errorMsgDuration:
            "For 1 min fidelity, duration should be at least 30 minutes",
        });
        lowerLimit = false;
      }

      if (
        lowerLimit &&
        this.state.duration > 0 &&
        this.state.duration < upperLimit &&
        this.state.parkingDuration >= 14 &&
        this.state.parkingDuration < 18
      ) {
        await this.setState({ enableSave: true });
      } else {
        await this.setState({ enableSave: false });
      }
    }
  }

  async savePref() {
    this.setState({ modalLoader: true, errorMsgDuration: "" });

    // let dateUtcStart = new Date().getTime();
    // let dateUtcEnd = new Date().getTime();

    let dateUtcStart = Date.parse(new Date());
    let dateUtcEnd = Date.parse(new Date());

    if (this.state.durationType === "ABSOLUTE") {
      const minHours = parseInt(this.state.absFrequency, 10) === 1 ? 1 : 5;
      const maxDays = parseInt(this.state.absFrequency, 10) === 1 ? 15 : 60;
      const minMinutes = parseInt(this.state.absFrequency, 10) === 1 ? 1 : 30;

      const start = this.state.startDate;
      const prevEnd = this.state.endDate;

      const diffInMinutes = (prevEnd - start) / (1000 * 60);
      const diffHours = (prevEnd - start) / (1000 * 60 * 60);
      const diffDay = (prevEnd - start) / (1000 * 60 * 60 * 24);

      const maxStartDate = new Date(start.getTime());
      // maxStartDate.setHours(maxStartDate.getHours() + minHours);
      maxStartDate.setMinutes(maxStartDate.getMinutes() + minMinutes);

      if (maxStartDate > new Date()) {
        await this.setState({
          errorMsgDuration: "Applied dates are not future dates",
          modalLoader: false,
        });
        return false;
      } else if (prevEnd > new Date()) {
        await this.setState({
          errorMsgDuration: "Applied dates are not future dates",
          modalLoader: false,
        });
        return false;
      } else if (
        diffInMinutes < 30 &&
        parseInt(this.state.absFrequency, 10) === 5
      ) {
        await this.setState({
          errorMsgDuration:
            "Minimum duration should be 30 mins with at least 5 data lines",
          modalLoader: false,
        });
        return false;
      }
      // else if (diffHours < minHours) {
      //   await this.setState({
      //     errorMsgDuration: `For ${this.state.absFrequency} min fidelity, min duration should be ${minHours} hrs.`,
      //     modalLoader: false,
      //   });
      //   return false;
      // } else if (diffDay > maxDays) {
      //   await this.setState({
      //     errorMsgDuration: `For ${this.state.absFrequency} min fidelity, max duration should be ${maxDays} days.`,
      //     modalLoader: false,
      //   });
      //   return false;
      // }
      else {
        dateUtcStart = Date.parse(this.state.startDate);
        dateUtcEnd = Date.parse(this.state.endDate);

        // dateUtcStart = new Date(this.state.startDate).getTime();
        // dateUtcEnd = new Date(this.state.endDate).getTime();
      }
    }

    const payload = {
      metricQueryDuration: this.state.duration,
      metricQueryDurationUnit: this.state.unit,
      parkingMetricQueryDuration: this.state.parkingDuration,
      parkingMetricQueryDurationUnit: "days", //this.state.parkingUnit
      relFrequency: this.state.interval,
      providerName: this.state.provider,
      durationType: this.state.durationType,
      startDate: dateUtcStart,
      endDate: dateUtcEnd,
      absFrequency: this.state.absFrequency,
    };

    apiFetch(Constdata.SET_METRIC_FETCH_DURATION, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((responseJson) => {
        this.setState({ modalLoader: false });
        this.props.handleRecommendationDurationPreference(responseJson);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async componentDidMount() {
    await this.setState({ modalLoader: true });
    this.props.registerListners(true);
    apiFetch(Constdata.GET_METRIC_FETCH_DURATION, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then(async (responseJson) => {
        if (responseJson.success === true) {
          this.setState({ durationResponse: responseJson.data });
          await this.setState({
            modalLoader: false,
            durationType:
              responseJson.data.durationType === ""
                ? this.state.durationType
                : responseJson.data.durationType,
            duration: responseJson.data.metricQueryDuration,
            unit: responseJson.data.metricQueryDurationUnit,
            parkingDuration: 17,
            parkingUnit: responseJson.data.parkingMetricQueryDurationUnit,
            interval:
              responseJson.data.relFrequency === 0
                ? this.state.interval
                : responseJson.data.relFrequency,
            absFrequency:
              responseJson.data.absFrequency === 0
                ? this.state.interval
                : responseJson.data.absFrequency,
            endDate: responseJson.data.endDate
              ? new Date(responseJson.data.endDate)
              : new Date(),
            startDate: responseJson.data.startDate
              ? new Date(responseJson.data.startDate)
              : new Date(),
          });

          if (
            responseJson.data.durationType === "RELATIVE" ||
            this.state.durationType === "RELATIVE"
          ) {
            if (this.state.unit === "hours") {
              document.getElementById("duration").setAttribute("max", 120);
            } else if (this.state.unit === "minutes") {
              document
                .getElementById("duration")
                .setAttribute("max", 60 * 5 + 1);

              if (this.state.interval === 1) {
                document.getElementById("duration").setAttribute("min", 30);
              } else {
                document.getElementById("duration").setAttribute("min", 30);
              }
            } else {
              if (this.state.interval === 1) {
                document.getElementById("duration").setAttribute("max", 15);
              } else {
                document.getElementById("duration").setAttribute("max", 60);
              }
            }
            if (this.state.unit === "") {
              this.setState({ unit: "hours", max: 120 });
            }
          }
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          await this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          await this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
            isRedirect: false,
          });
        }
      })
      .catch((error) => {
        console.error("error", error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
          isRedirect: false,
        });
      });
  }
  async changeInterval(e) {
    const value = e.target.value;

    if (value === "5" && this.state.unit === "hours") {
      if (this.state.duration < 6) {
        this.setState({ duration: 5 });
      }
    }

    if (value === "1" && this.state.unit === "minutes") {
      document.getElementById("duration").setAttribute("min", 30);
      // this.setState({ duration: 60 });
    } else if (value === "5" && this.state.unit === "minutes") {
      document.getElementById("duration").setAttribute("min", 30);
      if (!(this.state.duration > parseInt(30))) {
        this.setState({ duration: 30 });
      }
    }

    if (this.state.unit === "days") {
      if (value === "1") {
        document.getElementById("duration").setAttribute("max", 15);
        this.setState({ duration: 15 });
      } else if (value === "5") {
        document.getElementById("duration").setAttribute("max", 60);
      }
    }
    this.setState({ interval: parseInt(value) });
    await this.setState({ errorMsgDuration: "" });
    await this.manageAction();
  }

  toggleTooltips = () =>
    this.setState({ tooltipOpen: !this.state.tooltipOpen });

  toggleTooltipsInterval = () =>
    this.setState({ tooltipIntervalOpen: !this.state.tooltipIntervalOpen });

  freeTrialPlanSupport() {
    if (this.state.isFreeTrial) {
      if (this.state.userName === "support@serralabs.com") {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  // handle change
  handleAbsoluteChange = (field) => async (event) => {
    this.setState(
      {
        [field]: event,
      },
      async () => {
        await this.manageAction();
      }
    );
  };

  async changeIntervalAbsolute(e) {
    const value = e.target.value;
    this.setState(
      () => {
        let intervalState = {
          absFrequency: parseInt(value),
        };
        return intervalState;
      },
      async () => {
        await this.manageAction();
      }
    );
  }
  async changeDurationType(type) {
    this.setState(
      (prevState) => {
        const resp = prevState.durationResponse || {};
        return {
          durationType: type,
          duration: resp?.metricQueryDuration ?? 7,
          unit: resp?.metricQueryDurationUnit ?? "days",
          parkingDuration: 17,
          parkingUnit: resp?.parkingMetricQueryDurationUnit,
          interval: resp?.relFrequency === 0 ? 5 : resp?.relFrequency,
          absFrequency: resp?.absFrequency === 0 ? 5 : resp?.absFrequency,
          endDate: resp?.endDate ? new Date(resp.endDate) : new Date(),
          startDate: resp?.startDate ? new Date(resp.startDate) : new Date(),
        };
      },
      async (res) => {
        if (type === "RELATIVE") {
          const { metricQueryDurationUnit = "days", relFrequency = 5 } =
            this.state.durationResponse || {};

          if (metricQueryDurationUnit === "hours") {
            document.getElementById("duration").setAttribute("max", 120);
          } else if (metricQueryDurationUnit === "minutes") {
            document.getElementById("duration").setAttribute("max", 60 * 5 + 1);

            if (relFrequency === 1) {
              document.getElementById("duration").setAttribute("min", 30);
            } else {
              document.getElementById("duration").setAttribute("min", 30);
            }
          } else {
            if (relFrequency === 1) {
              document.getElementById("duration").setAttribute("min", 1);
              document.getElementById("duration").setAttribute("max", 15);
            } else {
              document.getElementById("duration").setAttribute("min", 5);
              document.getElementById("duration").setAttribute("max", 60);
            }
          }
          if (metricQueryDurationUnit === "") {
            this.setState({ unit: "hours", max: 120 });
          }
        }

        await this.manageAction();
      }
    );
  }

  handleChange = (date) => {
    this.setState({ startDate1: date });
  };

  formatWithTZ = (date) => {
    if (!date) return "";
    const formatter = new Intl.DateTimeFormat("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
    });

    const parts = formatter.formatToParts(date);
    const lookup = Object.fromEntries(parts.map((p) => [p.type, p.value]));

    return `${lookup.year}-${lookup.month}-${lookup.day} ${lookup.hour}:${lookup.minute} (${lookup.timeZoneName})`;
  };

  render() {
    const { startDate, endDate } = this.state;

    return (
      <div>
        <div
          className="container-verf container-verf-margin pageBgWhite"
          style={{ borderRadius: "10px" }}
          role="main"
        >
          <div className="frm-container">
            <Row>
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                <Label>Rightsizing Duration</Label>
              </div>
            </Row>

            <Row
              className="rightsizingDuration"
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "20px",
                justifyContent: "center",
                paddingBottom: "30px",
                gap: "20px",
              }}
            >
              <div class="form-check" style={{ width: "10%" }}>
                <input
                  class="form-check-input"
                  type="radio"
                  name="AWS"
                  id="aws"
                  checked={
                    this.state.durationType === "RELATIVE" ? true : false
                  }
                  onClick={() => this.changeDurationType("RELATIVE")}
                />
                <label class="form-check-label pl-2" for="aws">
                  Relative
                </label>
              </div>
              <div class="form-check" style={{ width: "10%" }}>
                <input
                  class="form-check-input"
                  type="radio"
                  name="Azure"
                  id="azure"
                  checked={
                    this.state.durationType === "ABSOLUTE" ? true : false
                  }
                  onClick={() => this.changeDurationType("ABSOLUTE")}
                />
                <label class="form-check-label pl-2" for="azure">
                  Absolute
                </label>
              </div>
            </Row>

            {this.state.durationType === "ABSOLUTE" && (
              <>
                <Row
                  className="rightsizingDurationAbsolute"
                  style={{
                    justifyContent: "center",
                    borderBottom: "1px solid #c9c9c9",
                    paddingBottom: "30px",
                  }}
                >
                  <div style={{ marginRight: "20px" }}>
                    <FormGroup>
                      <Label for="from">From</Label>
                      <DatePicker
                        id="from"
                        selected={startDate}
                        onChange={this.handleAbsoluteChange("startDate")}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={1}
                        dateFormat={`yyyy-MM-dd HH:mm`}
                        placeholderText="Select date and time"
                        className="form-control"
                        customInput={<CustomDateInput />}
                        value={this.formatWithTZ(startDate)}
                      />
                    </FormGroup>
                    {/* <FormGroup>
        <Label for="from">From</Label>
        <InputGroup>
          <Input
            id="from"
            type="datetime-local"
            value={`${this.state.startDate}`}
            onChange={this.handleAbsoluteChange("startDate")}
          />
      </FormGroup> */}

                    {this.state.errorMsgDuration !== "" ? (
                      <div>
                        <span
                          style={{
                            color: "red",
                            fontSize: "14px",
                            position: "absolute",
                          }}
                        >
                          {this.state.errorMsgDuration}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div style={{ marginRight: "20px" }}>
                    <FormGroup>
                      <Label for="toDate">To &nbsp;&nbsp;&nbsp;&nbsp;</Label>
                      <DatePicker
                        id="toDate"
                        selected={endDate}
                        onChange={this.handleAbsoluteChange("endDate")}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={1}
                        dateFormat={`yyyy-MM-dd HH:mm`}
                        placeholderText="Select date and time"
                        className="form-control"
                        minDate={this.state.startDate}
                        customInput={<CustomDateInput />}
                        value={this.formatWithTZ(endDate)}
                      />
                    </FormGroup>

                    {/* <FormGroup>
                      <Label for="toDate">To</Label>
                      <Input
                        id="toDate"
                        type="datetime-local"
                        value={this.state.endDate}
                        min={this.state.startDate}
                        onChange={this.handleAbsoluteChange("endDate")}
                      />
                    </FormGroup> */}
                  </div>
                  <div>
                    <div>
                      <FormGroup>
                        <div style={{ display: "flex" }}>
                          <Label for="unit">Best Fidelity</Label>
                          <div>
                            <i
                              id="Tooltip-Interval"
                              style={{ marginLeft: "7px", fontSize: "18px" }}
                              className="fa fa-info-circle"
                            />
                            <Tooltip
                              placement="bottom"
                              isOpen={this.state.tooltipIntervalOpen}
                              target={"Tooltip-Interval"}
                              toggle={this.toggleTooltipsInterval}
                              style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "left",
                                minWidth:
                                  window.innerWidth >= 1768
                                    ? "55%"
                                    : window.innerWidth >= 1621
                                    ? "60%"
                                    : window.innerWidth >= 1496
                                    ? "65%"
                                    : window.innerWidth >= 1354
                                    ? "72%"
                                    : "75%",
                              }}
                            >
                              <div style={{ lineHeight: 1.1 }}>
                                {this.state.provider === "AZURE"
                                  ? message.MetricDataIntervalInfoAzure
                                  : message.MetricDataIntervalInfo}
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                        <div>
                          <Input
                            type="select"
                            value={this.state.absFrequency}
                            onChange={this.changeIntervalAbsolute}
                            style={{ height: "38px" }}
                          >
                            <option value="1">1 Min</option>
                            <option value="5">5 Min</option>
                          </Input>
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                </Row>
              </>
            )}

            {this.state.durationType === "RELATIVE" && (
              <Row
                className="rightsizingDurationAbsolute"
                style={{
                  justifyContent: "center",
                  borderBottom: "1px solid #c9c9c9",
                  paddingBottom: "30px",
                }}
              >
                <div style={{ marginRight: "20px" }}>
                  <FormGroup>
                    <div style={{ display: "flex" }}>
                      <Label for="duration" style={{ width: "80px" }}>
                        Maximum Duration
                      </Label>

                      <div>
                        <i
                          id="Tooltip-Duration"
                          style={{ marginLeft: "7px", fontSize: "18px" }}
                          className="fa fa-info-circle"
                        ></i>
                        <Tooltip
                          placement="bottom"
                          isOpen={this.state.tooltipOpen}
                          target={"Tooltip-Duration"}
                          toggle={this.toggleTooltips}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid black",
                            textAlign: "left",
                            minWidth:
                              window.innerWidth >= 1702
                                ? "55%"
                                : window.innerWidth >= 1561
                                ? "60%"
                                : window.innerWidth >= 1379
                                ? "68%"
                                : "75%",
                          }}
                        >
                          <div style={{ lineHeight: 1.1 }}>
                            {" "}
                            {this.state.provider === "AZURE"
                              ? message.MetricDataDurationInfoAzure
                              : message.MetricDataDurationInfo}
                          </div>
                        </Tooltip>
                      </div>
                    </div>

                    <div>
                      <Input
                        type="number"
                        pattern="[1-9]"
                        step="1"
                        min={this.state.min}
                        max={this.state.max}
                        name="duration"
                        id="duration"
                        placeholder="Duration"
                        value={this.state.duration}
                        onChange={this.changeDuration}
                        onKeyDown={this.keyPress}
                      />
                    </div>
                  </FormGroup>
                  {this.state.errorMsgDuration !== "" ? (
                    <div>
                      <span
                        style={{
                          color: "red",
                          fontSize: "14px",
                          position: "absolute",
                        }}
                      >
                        {this.state.errorMsgDuration}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ marginRight: "20px" }}>
                  <FormGroup>
                    <Label for="unit" style={{ paddingTop: "24px" }}>
                      Unit
                    </Label>
                    <div>
                      <Input
                        type="select"
                        value={this.state.unit}
                        onChange={this.changeUnit}
                        style={{ height: "38px" }}
                      >
                        <option value="hours">Hour(s)</option>
                        <option value="days">Day(s)</option>
                        <option value="minutes">minutes</option>
                      </Input>
                    </div>
                  </FormGroup>
                </div>
                <div>
                  <FormGroup>
                    <div style={{ display: "flex" }}>
                      <Label for="unit" style={{ width: "50px" }}>
                        Best Fidelity
                      </Label>
                      <div>
                        <i
                          id="Tooltip-Interval"
                          style={{ marginLeft: "7px", fontSize: "18px" }}
                          className="fa fa-info-circle"
                        />
                        <Tooltip
                          placement="bottom"
                          isOpen={this.state.tooltipIntervalOpen}
                          target={"Tooltip-Interval"}
                          toggle={this.toggleTooltipsInterval}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid black",
                            textAlign: "left",
                            minWidth:
                              window.innerWidth >= 1768
                                ? "55%"
                                : window.innerWidth >= 1621
                                ? "60%"
                                : window.innerWidth >= 1496
                                ? "65%"
                                : window.innerWidth >= 1354
                                ? "72%"
                                : "75%",
                          }}
                        >
                          <div style={{ lineHeight: 1.1 }}>
                            {this.state.provider === "AZURE"
                              ? message.MetricDataIntervalInfoAzure
                              : message.MetricDataIntervalInfo}
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <div>
                      <Input
                        type="select"
                        id="interval"
                        value={this.state.interval}
                        onChange={this.changeInterval}
                      >
                        <option value="1">1 Min</option>
                        <option value="5">5 Min</option>
                      </Input>
                    </div>
                  </FormGroup>
                </div>
              </Row>
            )}

            <div
              class="btn-toolbar pageBgWhite"
              role="toolbar"
              aria-label="Toolbar with button groups"
              style={{
                display: "flex",
                padding: "20px",
                marginTop: "20px",
                justifyContent: "flex-end",
                borderRadius: "0px 0px 10px 10px",
              }}
            >
              <div
                class="mr-2"
                role="group"
                aria-label="Third group"
                className="modalBtn"
                id="knowMoreFooter"
              >
                <Button
                  id={
                    this.freeTrialPlanSupport() || !this.state.enableSave
                      ? "GOTO_listdisabled"
                      : "confirmbtn_list"
                  }
                  onClick={this.savePref}
                  className="btn-detils"
                  disabled={
                    this.freeTrialPlanSupport() || !this.state.enableSave
                  }
                >
                  Save
                </Button>
              </div>
              <div role="group" aria-label="First group">
                <Button
                  className="btn-cancel btn btn-light"
                  onClick={this.props.toggle}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
        {this.state.errorPopup === true ? (
          <SerraError
            Errordata={this.state.errormessage}
            ErrorPopup={this.state.errorPopup}
            setErrorMethod={this.setErrorPopupState}
            isError={this.state.isErrorHeader}
          ></SerraError>
        ) : (
          ""
        )}
        {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
      </div>
    );
  }
}

export default Preferences;
